export default __webpack_public_path__ + "static/media/route-control-logo-512px.03190ac9.png";